import {safelyGetFilterByKey} from 'nutshell-core/filter';
import type {FilterObject} from 'nutshell-core/types';

import type {GetEventsVariables as GetEventsQueryVariables} from 'nutshell-graphql-types';

const LIMIT = 20;

export function getEventsQueryVariables(input: {
    entityId: string | null | undefined;
    activeFilters: FilterObject[];
    excludeOutreach?: boolean;
    excludeInteractions?: boolean;
    excludeCustomerJourneys?: boolean;
    after: string | null | undefined;
}): GetEventsQueryVariables {
    const {
        entityId,
        activeFilters,
        excludeOutreach,
        excludeInteractions,
        excludeCustomerJourneys,
        after,
    } = input;

    return {
        entityId,
        first: LIMIT,
        after,
        filters: {
            entryTypes: getFilterIds(activeFilters, 'payload'),
            creatorIds: getFilterIds(activeFilters, 'creator'),
            activityTypeIds: getFilterIds(activeFilters, 'activityType'),
            period: safelyGetFilterByKey(activeFilters, 'period'),
            excludeOutreach: excludeOutreach || false,
            excludeInteractions: excludeInteractions || false,
            excludeCustomerJourneys: excludeCustomerJourneys || false,
        },
    };
}

export function getFilterIds(activeFilters: FilterObject[], key: string) {
    const filterObject: any | null | undefined = safelyGetFilterByKey(activeFilters, key);

    // @ts-expect-error
    return filterObject && filterObject.data ? filterObject.data.map((d) => d.data) : undefined;
}
